import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card-body d-flex flex-column px-4 py-0" }
const _hoisted_2 = { class: "d-flex flex-column mb-5" }
const _hoisted_3 = { class: "text-dark text-hover-primary fw-bold fs-3" }
const _hoisted_4 = {
  key: 0,
  class: "row g-0"
}
const _hoisted_5 = { class: "d-flex align-items-center mb-4 me-2" }
const _hoisted_6 = { class: "symbol symbol-40px me-3 border border-gray-800" }
const _hoisted_7 = { class: "fs-7 text-gray-900 fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"]),
    style: _normalizeStyle(`background-color: ${_ctx.widgetColor}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ]),
      (_ctx.items.length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-6"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`symbol-label bg-${item.params} fw-bolder fs-2 text-black`)
                    }, _toDisplayString(item.quantity), 3)
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            "image-size": 50,
            description: "Sin resultados"
          }))
    ])
  ], 6)), [
    [_directive_loading, _ctx.loading]
  ])
}